import type { ReactNode } from "react";

interface Props {
  variant: "error" | "warning" | "success" | "info";
  icon: string;
  title: string;
  subtitle?: string;
  summary?: string;
  children?: ReactNode;
}

export function AttentionCategory({ variant, icon, title, subtitle, summary, children }: Props) {
  return (
    <section className={`attention-category ${variant}`}>
      <header className="attention-category-header">
        <span className="attention-category-icon">{icon}</span>
        <span className="attention-category-title">{title}</span>
        {summary && <span className="attention-category-summary">{summary}</span>}
      </header>
      {subtitle && <div className="attention-category-subtitle">{subtitle}</div>}
      <div className="attention-category-body">{children}</div>
    </section>
  );
}
